export default "__VITE_ASSET__0db98a49__"